import type { StyledComponent } from 'styled-components';
import styled, { css } from 'styled-components';
import type { SpinProps } from 'antd/lib/spin';
import Spin from 'antd/lib/spin';

export type StyledSpinProps = SpinProps & { position?: 'center' };

export const StyledSpin: StyledComponent<typeof Spin, StyledSpinProps, StyledSpinProps> = styled(
  Spin,
)<StyledSpinProps>`
  ${props =>
    props.position === 'center' &&
    css`
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;
